import { getAverage } from '@akin-home/arrays';
import { getLast7Days, getLast7Months, getLast7Weeks } from '@akin-home/dates';
import { endOfMonth, endOfWeek, format } from 'date-fns';
import { getGoalProgressPercentage } from '.';
import { Goal } from '../types';

interface Options {
  user_id: string;
  date: Date;
  period: 'day' | 'week' | 'month';
}

export const getGoalProductivityData = (
  goals: Goal[],
  { user_id, date, period }: Options
) => {
  switch (period) {
    case 'day': {
      const last7Days = getLast7Days(date);

      return {
        labels: last7Days.map((day) => format(day, 'dd MMM')),
        datasets: [
          {
            data: last7Days.map((day) =>
              getAverage(
                goals.map((goal) =>
                  getGoalProgressPercentage(goal, { date: day, user_id })
                )
              )
            ),
          },
          {
            data: [100],
          },
        ],
      };
    }
    case 'week': {
      const last7Weeks = getLast7Weeks(endOfWeek(date));

      return {
        labels: last7Weeks.map((day) => format(day, 'dd MMM')),
        datasets: [
          {
            data: last7Weeks.map((week) =>
              getAverage(
                goals.map(
                  (goal) =>
                    (goal.getCompletionsForWeek(week, user_id) /
                      goal.toCompleteForWeek(week)) *
                    100
                )
              )
            ),
          },
          {
            data: [100],
          },
        ],
      };
    }
    case 'month': {
      const last7Months = getLast7Months(endOfMonth(date));

      return {
        labels: last7Months.map((day) => format(day, 'MMM')),
        datasets: [
          {
            data: last7Months.map((month) =>
              getAverage(
                goals.map(
                  (goal) =>
                    (goal.getCompletionsForMonth(month, user_id) /
                      goal.toCompleteForMonth(month)) *
                    100
                )
              )
            ),
          },
          {
            data: [100],
          },
        ],
      };
    }
  }
};
